import { useState } from "react";
import { Play } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

const VIDEOS = [
  { id: "BlVulGoH7Fo", title: "how to become so charismatic, you make others insecure." },
  { id: "AIT1CKm7g2Y", title: "Flirting Secrets The Top 1% Use" },
  { id: "Dh3AXlgvEN8", title: "A Realistic Approach at a Mall (Infield)" },
];

export const VideoCard = ({ video, index, testIdPrefix = "video" }) => {
  const [playing, setPlaying] = useState(false);
  return (
    <Reveal delay={index * 0.1}>
      <div className="group" data-testid={`${testIdPrefix}-card-${index + 1}`}>
        <div className="relative aspect-video overflow-hidden border border-white/10 bg-[#141414]">
          {playing ? (
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${video.id}?rel=0&autoplay=1`}
              title={video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 h-full w-full"
              data-testid={`${testIdPrefix}-iframe-${index + 1}`}
            />
          ) : (
            <button
              onClick={() => setPlaying(true)}
              aria-label={`Play ${video.title}`}
              className="absolute inset-0 block h-full w-full"
              data-testid={`${testIdPrefix}-play-${index + 1}`}
            >
              <img
                src={`https://i.ytimg.com/vi/${video.id}/maxresdefault.jpg`}
                alt={video.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute inset-0 bg-black/30 transition-colors duration-500 group-hover:bg-black/10" />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="flex h-14 w-14 items-center justify-center rounded-full border border-white/40 bg-black/40 text-white backdrop-blur-md transition-all duration-500 group-hover:scale-110 group-hover:border-white group-hover:bg-white group-hover:text-black">
                  <Play className="ml-0.5 h-5 w-5 fill-current" />
                </span>
              </span>
            </button>
          )}
        </div>
        <p className="mt-4 font-serif text-lg font-light italic leading-snug text-neutral-300" data-testid={`${testIdPrefix}-title-${index + 1}`}>
          {video.title}
        </p>
      </div>
    </Reveal>
  );
};

export default function Videos() {
  return (
    <section id="videos" className="mx-auto max-w-6xl px-6 py-28 text-center lg:px-10 lg:py-40" data-testid="videos-section">
      <Reveal>
        <div className="flex flex-col items-center gap-6">
          <div>
            <Overline>Featured Videos</Overline>
            <h2 className="mt-6 font-serif text-4xl font-light tracking-tight sm:text-5xl">
              From the <span className="italic text-neutral-400">channel.</span>
            </h2>
          </div>
          <a
            href="https://www.youtube.com/@sergjchavez"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="videos-channel-link"
            className="w-fit border border-white/30 px-6 py-3 text-xs font-semibold uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-white hover:text-black"
          >
            Visit @sergjchavez
          </a>
        </div>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-8 text-left md:grid-cols-3">
        {VIDEOS.map((v, i) => (
          <VideoCard key={v.id} video={v} index={i} />
        ))}
      </div>
    </section>
  );
}
